import { render, staticRenderFns } from "./AdvisorFormBuilder.vue?vue&type=template&id=1497bc74&"
import script from "./AdvisorFormBuilder.vue?vue&type=script&lang=js&"
export * from "./AdvisorFormBuilder.vue?vue&type=script&lang=js&"
import style0 from "./AdvisorFormBuilder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports